import { l10n } from '@ott/l10n';

export const FORM_FIELDS = {
  EMAIL: 'email',
} as const;

export const SUBSCRIPTIONS_EMAIL_KEY = 'subscriptionsEmail';

export const defaultTooltipErrors = {
  [FORM_FIELDS.EMAIL]: l10n('emailSubscription.form.tooltip'),
};

export const defaultTexts = {
  title: l10n('emailSubscription.content.title'),
  description: l10n('emailSubscription.content.description'),
  successTitle: l10n('emailSubscription.success.title'),
  successDescription: l10n('emailSubscription.success.description'),
};
